import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const useIntegrationsSummary = (param)=>{
    let { enabled, refreshOnHookMount = false, withLoader = false } = param;
    var _useStore;
    const { api } = useStoreActions();
    const businessId = (_useStore = useStore(selectors.user.business)) === null || _useStore === void 0 ? void 0 : _useStore.id;
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.IntegrationsSummary,
            businessId
        ],
        queryFn: ()=>api.integration.getSummary(),
        enabled,
        staleTime: 2000,
        refreshOnHookMount,
        withLoader
    });
    return {
        integrationsSummary: data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
